interface AuditLogQueryArgs {
  organisationId?: string;
  actor?: string;
  target?: string;
  action?: string;
  fromDate?: string;
  toDate?: string;
  limit: number;
}

export interface AuditLogFilterValues {
  organisationId: string;
  actor: string;
  target: string;
  action: string;
  fromDate: string;
  toDate: string;
}

const readTrimmedSearchParam = (
  searchParams: URLSearchParams,
  key: string,
): string => searchParams.get(key)?.trim() ?? "";

export const buildAuditLogFilterValuesFromSearchParams = (
  searchParams: URLSearchParams,
): AuditLogFilterValues => ({
  organisationId:
    readTrimmedSearchParam(searchParams, "organisationId") ||
    readTrimmedSearchParam(searchParams, "organizationId"),
  actor: readTrimmedSearchParam(searchParams, "actor"),
  target: readTrimmedSearchParam(searchParams, "target"),
  action: readTrimmedSearchParam(searchParams, "action"),
  fromDate: readTrimmedSearchParam(searchParams, "fromDate"),
  toDate: readTrimmedSearchParam(searchParams, "toDate"),
});

export const buildAuditLogSearchParams = (
  filters: AuditLogFilterValues,
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  const queryArgs = buildAuditLogQueryArgs(filters);

  Object.entries(queryArgs).forEach(([key, value]) => {
    if (key === "limit" || typeof value !== "string") {
      return;
    }

    searchParams.set(key, value);
  });

  return searchParams;
};

export const buildAuditLogQueryArgs = (args: {
  organisationId: string;
  actor: string;
  target: string;
  action: string;
  fromDate: string;
  toDate: string;
  limit?: number;
}): AuditLogQueryArgs => {
  const queryArgs: AuditLogQueryArgs = {
    limit: args.limit ?? 200,
  };

  const organisationId = args.organisationId.trim();
  const actor = args.actor.trim();
  const target = args.target.trim();
  const action = args.action.trim();
  const fromDate = args.fromDate.trim();
  const toDate = args.toDate.trim();

  if (organisationId.length > 0) {
    queryArgs.organisationId = organisationId;
  }
  if (actor.length > 0) {
    queryArgs.actor = actor;
  }
  if (target.length > 0) {
    queryArgs.target = target;
  }
  if (action.length > 0) {
    queryArgs.action = action;
  }
  if (fromDate.length > 0) {
    queryArgs.fromDate = fromDate;
  }
  if (toDate.length > 0) {
    queryArgs.toDate = toDate;
  }

  return queryArgs;
};
